import React from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from '../context/AdminAuthContext';
import { AdminLogin } from './AdminLogin';
import { AdminSidebar } from './AdminSidebar';
import { AdminDashboard } from './AdminDashboard';
import { AdminProductTypes } from './AdminProductTypes';
import { AdminBrands } from './AdminBrands';
import { AdminFiles } from './AdminFiles';
import { AdminUsersList } from './AdminUsersList';
import { AdminPlans } from './AdminPlans';
import { AdminSettings } from './AdminSettings';
import { AdminRequests } from './AdminRequests';
import { AdminBlog } from './AdminBlog';
const AdminContent = () => {
  const { isAdminAuthenticated } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (!isAdminAuthenticated) {
    return <AdminLogin />;
  }

  const activePage = location.pathname.split('/admin/')[1] || 'dashboard-overview';

  const handleNavigate = (pageId) => {
    navigate(`/admin/${pageId}`);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#1c2529' }}>
      <AdminSidebar activePage={activePage} onNavigate={handleNavigate} />
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <Routes>
          <Route path="/" element={<Navigate to="dashboard-overview" replace />} />
          <Route path="dashboard-overview" element={<AdminDashboard />} />
          <Route path="products-types" element={<AdminProductTypes />} />
          <Route path="products-brands" element={<AdminBrands />} />
          <Route path="products-files" element={<AdminFiles />} />
          <Route path="users-list" element={<AdminUsersList />} />
          <Route path="plans-list" element={<AdminPlans />} />
          <Route path="settings-general" element={<AdminSettings />} />
          <Route path="requests-list" element={<AdminRequests />} />
          <Route path="blog-posts" element={<AdminBlog />} />
          <Route
            path="*"
            element={
              <div className="w3-text-white w3-center" style={{ padding: 60 }}>
                این بخش هنوز پیاده‌سازی نشده است.
              </div>
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export const AdminApp = () => {
  return (
    <AdminAuthProvider>
      <AdminContent />
    </AdminAuthProvider>
  );
};